export default class MenuToggle {
  constructor(menuButtonId, menuCloseId, menuId, bodyTag, overlayId) {
    this.menuButton = document.getElementById(menuButtonId);
    this.menuClose = document.getElementById(menuCloseId);
    this.menu = document.getElementById(menuId);
    this.body = document.querySelector(bodyTag);
    this.overlay = document.getElementById(overlayId);

    this.handleMenuButtonClick = this.handleMenuButtonClick.bind(this);
    this.handleMenuCloseClick = this.handleMenuCloseClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);

    this.init();
  }

  init() {
    if (this.menuButton && this.menu && this.menuClose) {
      this.menuButton.addEventListener('click', this.handleMenuButtonClick);
      this.menuClose.addEventListener('click', this.handleMenuCloseClick);
      document.addEventListener('click', this.handleDocumentClick);
    }
  }

  handleMenuButtonClick(event) {
    event.stopPropagation();
    this.menu.classList.add('!left-0', '!opacity-100', '!visible');
    this.body.classList.add('overflow-hidden');
    this.overlay.classList.add('!visible', '!opacity-25');
  }

  handleMenuCloseClick(event) {
    event.stopPropagation();
    this.menu.classList.remove('!left-0', '!opacity-100', '!visible');
    this.body.classList.remove('overflow-hidden');
    this.overlay.classList.remove('!visible', '!opacity-25');
  }

  handleDocumentClick(event) {
    if (!this.menu.contains(event.target) && this.menu.classList.contains('!left-0')) {
      this.menu.classList.remove('!left-0', '!opacity-100', '!visible');
      this.body.classList.remove('overflow-hidden');
      this.overlay.classList.remove('!visible', '!opacity-25');
    }
  }
}
